import cssTokens from './WixDesignSystemProvider/newBrandingTokens';

export const COLOR_TOKENS = cssTokens();
